import React from 'react';
import { App, ConfigProvider, ConfigProviderProps, ThemeConfig, theme } from 'antd';
import enUS from 'antd/es/locale/en_US';

const COLOR_PRIMARY_HOVER = '#ff933b';
const COLOR_TEXT = 'rgba(0, 0, 0, 0.85)';

const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#FC7411',
    colorLink: '#FC7411',
    colorLinkHover: COLOR_PRIMARY_HOVER,
    colorLinkActive: '#d65504',
    colorSuccess: '#3BC974',
    colorError: '#FF2E00',
    fontFamily: "'Proxima Nova', Corbel, Arial, sans-serif",
    colorText: COLOR_TEXT,
    colorTextHeading: COLOR_TEXT,
    colorTextSecondary: 'rgba(0, 0, 0, 0.45)',
    colorTextPlaceholder: '#bfbfbf',
    colorSplit: '#f0f0f0',
    colorBgLayout: '#f0f2f5',
    colorBgContainerDisabled: '#f5f5f5',
    lineHeight: 1.5715,
    borderRadius: 2,
    borderRadiusLG: 2,
    borderRadiusSM: 2,
    borderRadiusXS: 2,
    borderRadiusOuter: 2,
    wireframe: true,
    fontWeightStrong: 500,
    controlOutline: 'rgba(252, 116, 17, 0.2)',
    colorErrorOutline: 'rgba(255, 46, 0, 0.2)',
  },
  components: {
    Divider: {
      colorSplit: 'rgba(0, 0, 0, 0.06)',
    },
    Input: {
      activeBorderColor: COLOR_PRIMARY_HOVER,
    },
    InputNumber: {
      activeBorderColor: COLOR_PRIMARY_HOVER,
    },
    Select: {
      optionSelectedFontWeight: 600,
      activeBorderColor: COLOR_PRIMARY_HOVER,
    },
    Table: {
      headerSplitColor: 'transparent',
    },
    Button: {
      iconGap: 0,
      defaultGhostColor: COLOR_TEXT,
      defaultGhostBorderColor: '#d9d9d9',
      textHoverBg: 'rgba(0, 0, 0, 0.018)',
      primaryShadow: '0 2px 0 rgba(0, 0, 0, 0.045)',
      defaultShadow: '0 2px 0 rgba(0, 0, 0, 0.015)',
      dangerShadow: '0 2px 0 rgba(0, 0, 0, 0.045)',
    },
    Tooltip: {
      sizePopupArrow: 8,
    },
    Popover: {
      sizePopupArrow: 12,
    },
    Steps: {
      iconFontSize: 16,
    },
    Progress: {
      remainingColor: '#f5f5f5',
    },
    DatePicker: {
      activeBorderColor: COLOR_PRIMARY_HOVER,
      padding: 11,
      paddingXXS: 2,
      sizePopupArrow: 10,
      colorIcon: 'rgba(0, 0, 0, 0.25)',
      colorIconHover: 'rgba(0, 0, 0, 0.85)',
    },
  },
};

export const antdTokens = theme.getDesignToken(antdTheme);

const drawerConfig: ConfigProviderProps['drawer'] = { closable: { placement: 'end' } };

const locale: ConfigProviderProps['locale'] = { ...enUS, Empty: { description: 'No Data' } };

export const AntdThemeProvider = ({ children }: React.PropsWithChildren) => (
  <ConfigProvider theme={antdTheme} drawer={drawerConfig} locale={locale}>
    <App component={false}>{children}</App>
  </ConfigProvider>
);
